import {request, formatter} from '@/utils/request';

export namespace OaForm {
  export const Path = {
    Get: '/expenseapi/oaForm/get',
  };

  export async function get(oaFormNo: string) {
    const options = {
      method: 'GET',
      body: {
        id: oaFormNo
      },
    };
    return request<API.ResponseResult<API.OaForm>>(Path.Get, formatter(options));
  }


}
